import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Lock, User, KeyRound, Eye, EyeOff } from "lucide-react";
import { colors, fonts, spacing, radius } from "../../theme";
import { useAdminAuth } from "../../hooks/useSettings";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    if (e) e.preventDefault();
    setSubmitting(true);
    setError(null);
    const err = await login(user, pass);
    setSubmitting(false);
    if (!err) navigate("/admin/settings", { replace: true });
    else setError(err);
  };

  const label = { fontFamily: fonts.body, fontWeight: 500, fontSize: 11, color: colors.muted, textTransform: "uppercase", letterSpacing: 1.2, marginBottom: spacing.sm, marginTop: spacing.md, display: "block" };
  const inputWrap = { display: "flex", alignItems: "center", gap: spacing.sm, border: `0.5px solid ${colors.border}`, borderRadius: radius.md, backgroundColor: colors.surfaceSecondary, paddingLeft: spacing.md, paddingRight: spacing.md, height: 48 };
  const input = { flex: 1, color: colors.onSurface, fontFamily: fonts.body, fontSize: 15, background: "transparent", border: "none" };

  return (
    <div className="pm-fade" style={{ minHeight: "100vh", backgroundColor: colors.surface, paddingLeft: spacing.xl, paddingRight: spacing.xl, paddingTop: spacing.lg, paddingBottom: spacing.xl }}>
      <div className="pm-press" onClick={() => navigate(-1)} style={{ display: "flex", alignItems: "center", gap: 4, width: "fit-content", paddingTop: 8, paddingBottom: 8 }}>
        <ChevronLeft size={22} color={colors.onSurface} strokeWidth={2} />
        <span style={{ color: colors.onSurface, fontFamily: fonts.body, fontWeight: 500, fontSize: 14 }}>Indietro</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: spacing.xxl }}>
        <div style={{ width: 56, height: 56, borderRadius: 28, border: `0.5px solid ${colors.brandPrimary}`, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(196,164,100,0.08)" }}>
          <Lock size={22} color={colors.brandPrimary} strokeWidth={1.75} />
        </div>
        <div style={{ marginTop: spacing.lg, fontFamily: fonts.body, fontSize: 10, letterSpacing: 2, textTransform: "uppercase", color: colors.brandPrimary, fontWeight: 500 }}>Area riservata</div>
        <div style={{ marginTop: 4, fontFamily: fonts.display, fontSize: 30, fontWeight: 700, color: colors.onSurface }}>Accesso Gestore</div>
        <div style={{ width: 40, height: 1, backgroundColor: colors.brandPrimary, opacity: 0.7, margin: `${spacing.md}px 0` }} />
        <div style={{ fontFamily: fonts.body, fontSize: 13, color: colors.muted, textAlign: "center", letterSpacing: 0.3, paddingLeft: spacing.xl, paddingRight: spacing.xl }}>Accedi per modificare le informazioni del ristorante.</div>
      </div>

      <form onSubmit={submit} style={{ marginTop: spacing.xxl }}>
        <label style={label}>Username</label>
        <div style={inputWrap}>
          <User size={16} color={colors.muted} strokeWidth={1.75} />
          <input style={input} value={user} onChange={(e) => setUser(e.target.value)} autoCapitalize="none" autoCorrect="off" placeholder="username" />
        </div>

        <label style={label}>Password</label>
        <div style={inputWrap}>
          <KeyRound size={16} color={colors.muted} strokeWidth={1.75} />
          <input style={input} type={showPass ? "text" : "password"} value={pass} onChange={(e) => setPass(e.target.value)} placeholder="password" />
          <span className="pm-press" onClick={() => setShowPass((v) => !v)} style={{ display: "flex" }}>
            {showPass ? <EyeOff size={16} color={colors.muted} strokeWidth={1.75} /> : <Eye size={16} color={colors.muted} strokeWidth={1.75} />}
          </span>
        </div>

        {!!error && <div style={{ marginTop: spacing.md, color: colors.errorText, fontFamily: fonts.body, fontWeight: 500, fontSize: 13 }}>{error}</div>}

        <button type="submit" className="pm-press" disabled={submitting || !user || !pass} style={{ marginTop: spacing.xl, width: "100%", backgroundColor: colors.brandPrimary, border: "none", paddingTop: 14, paddingBottom: 14, borderRadius: radius.md, opacity: submitting || !user || !pass ? 0.5 : 1, color: colors.onBrandPrimary, fontFamily: fonts.body, fontWeight: 700, fontSize: 14, letterSpacing: 0.8, textTransform: "uppercase", cursor: "pointer" }}>Accedi</button>
      </form>
    </div>
  );
}
